// @flow
import React from 'react'
import VideoPlayer from '../videoPlayer/VideoPlayer'

import './styles.scss'

import Stars from '../vote/stars'
import { calculateScore } from 'components/main/helpers';

require('@ta-interaktiv/semantic-ui/semantic/dist/components/item.css')
require('@ta-interaktiv/semantic-ui/semantic/dist/components/image.css')
require('@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css')
require('@ta-interaktiv/semantic-ui/semantic/dist/components/header.css')

type Props = {
  name: string,
  fullName: String,
  avatarSrc: string,
  description: string,
  byline: string,
  portraitLink: string,
  entries: object,
  dynamicEntries: number,
  staticEntries: number
}

/**
 * Render a profile block.
 * @param {string} props.name Name of the person.
 * @param {string} props.avatarSrc Source URL of the avatar image.
 * @param {string} props.description The description of the person. Placed
 * @param {number} props.rating
 * between the <Profile> tages.
 * @returns {XML}
 */
export default function profile(props: Props) {
  const verdictKeys = Object.keys(props.staticEntries)
  const averageJuryStars = verdictKeys.reduce((prev, curr) => prev += props.staticEntries[curr].stars, 0) / props.amountOfChallenges
  const participants = props.dynamicEntries.data.p
  const votes = props.dynamicEntries.data.v
  const rating = calculateScore(votes, participants, averageJuryStars)

  return (
    <section className='ui grid profile'>
      <div className='row'>
        <div className='eight wide centered column'>
          <div className='person'>
            <img
              src={props.avatarSrc}
              alt={`Bild von ${props.fullName}`}
              className='ui circular centered image'
            />
            <div className='name'>{props.fullName}</div>
            <div className='byline'>{props.byline}</div>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='twelve wide centered column'>
          <p>Challenge-Resultat:</p>
          <Stars averageRating={rating} votingIsOver standalone />
        </div>
      </div>
      <div className='row'>
        <div className='twelve wide centered column'>
          <div className='description'>
            {props.description}{' '}
            <a href={props.portraitLink}>
              <i className='external icon' />Zum Porträt
            </a>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='ten wide centered column'>
          <VideoPlayer
            trackingID={props.name}
            source={require(`./videos/${props.name}.mp4`)}
            poster={require(`./videos/teaserbild-${props.name}.jpg`)}
          />
        </div>
      </div>
      <div className='row'>
        <div className='sixteen wide column'>
          <hr />
        </div>
      </div>
    </section>
  )
}
